import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = ["value", "onBlur"]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.t('cart')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  ($setup.cartItems.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_ion_list, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cartItems, (item, index) => {
                              return (_openBlock(), _createBlock(_component_ion_item, {
                                key: item.productId
                              }, {
                                default: _withCtx(() => [
                                  (item.productImage)
                                    ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
                                        key: 0,
                                        slot: "start",
                                        "router-link": {
                name: 'ProductDetailPage',
                params: { id: item.productId }
              }
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            src: item.productImage
                                          }, null, 8, _hoisted_3)
                                        ]),
                                        _: 2
                                      }, 1032, ["router-link"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h3", null, [
                                        _createElementVNode("b", null, _toDisplayString(item.productName), 1),
                                        _hoisted_4,
                                        _createVNode(_component_ion_note, { color: "dark" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(item.variantTitle), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createElementVNode("p", null, "HK$" + _toDisplayString(Number(item.unitPrice).toLocaleString()) + " / 1", 1),
                                      _createElementVNode("p", null, _toDisplayString($setup.t('CartPage.lineTotal')) + "HK$" + _toDisplayString(Number(item.unitPrice * item.quantity).toLocaleString()), 1),
                                      _createVNode(_component_ion_item, {
                                        class: "ion-no-padding",
                                        lines: "none"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_button, {
                                            class: "qty-action-btn",
                                            onClick: ($event: any) => ($setup.decrementCartItemQty(item))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                slot: "icon-only",
                                                icon: $setup.remove
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createElementVNode("input", {
                                            class: "quantity-input",
                                            type: "number",
                                            min: "0",
                                            max: "99",
                                            step: "1",
                                            value: item.quantity,
                                            onBlur: ($event: any) => ($setup.onFinishInputCartItemQty(item, $event)),
                                            placeholder: "0"
                                          }, null, 40, _hoisted_5),
                                          _createVNode(_component_ion_button, {
                                            class: "qty-action-btn",
                                            onClick: ($event: any) => ($setup.incrementCartItemQty(item))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                slot: "icon-only",
                                                icon: $setup.add
                                              }, null, 8, ["icon"])
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_component_ion_buttons, { slot: "end" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_button, {
                                                slot: "icon-only",
                                                onClick: ($event: any) => ($setup.removeCartItem(item, index))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, { icon: $setup.trash }, null, 8, ["icon"])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128)),
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("b", null, _toDisplayString($setup.t('CartPage.orderTotal')) + "HK$" + _toDisplayString($setup.getCartTotal().toLocaleString()), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          fill: "outline",
                          "router-link": {
            name: 'CheckoutPage',
            state: { passedCartItems: JSON.stringify($setup.cartItems) }
          }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('CartPage.checkout')), 1)
                          ]),
                          _: 1
                        }, 8, ["router-link"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_ion_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { class: "ion-text-center" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($setup.t('CartPage.emptyCart')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          "router-link": "/products"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.t('CartPage.shopNow')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}